export default [
    {
        "name": "江城明珠豪生大酒店",
        "income": 63841.2,
        "laxin": 2619.55,
        "id": 5
    },
    {
        "name": "宁波华侨温德姆至尊豪廷大酒店",
        "income": 63780.26,
        "laxin": 4286.85,
        "id": 7
    },
    {
        "name": "大连百年汇豪生酒店",
        "income": 14722.46,
        "laxin": 679.07,
        "id": 10
    },
    {
        "name": "合肥两淮豪生大酒店",
        "income": 35812.1,
        "laxin": 2438.77,
        "id": 12
    },
    {
        "name": "宁波逸东豪生大酒店",
        "income": 33646.37,
        "laxin": 1855.59,
        "id": 28
    },
    {
        "name": "蚌埠南山豪生大酒店",
        "income": 35952.01,
        "laxin": 2166.04,
        "id": 37
    },
    {
        "name": "滁州凯迪温德姆至尊豪廷大酒店",
        "income": 35086.1,
        "laxin": 2250.78,
        "id": 65
    },
    {
        "name": "南京卧龙湖温德姆至尊豪廷度假酒店",
        "income": 13382.6,
        "laxin": 863.28,
        "id": 80
    },
    {
        "name": "长兴温德姆至尊豪廷大酒店",
        "income": 37831.74,
        "laxin": 2490.49,
        "id": 82
    },
    {
        "name": "阜阳宝龙温德姆至尊豪廷大酒店",
        "income": 33676.19,
        "laxin": 2167.75,
        "id": 84
    },
    {
        "name": "安吉凯承温德姆至尊豪廷大酒店",
        "income": 50434.92,
        "laxin": 2638.85,
        "id": 91
    },
    {
        "name": "武汉光谷豪生行政公寓",
        "income": 32332.06,
        "laxin": 1373.85,
        "id": 902
    },
    {
        "name": "淮北静安豪生酒店",
        "income": 22064.04,
        "laxin": 1508.7,
        "id": 905
    },
    {
        "name": "昆明南亚风情园豪生大酒店",
        "income": 29282.54,
        "laxin": 2339.62,
        "id": 23
    },
    {
        "name": "昆明七彩云南温德姆至尊豪廷大酒店",
        "income": 60394.73,
        "laxin": 3067.17,
        "id": 32
    },
    {
        "name": "成都高新豪生大酒店",
        "income": 45967.33,
        "laxin": 2138.85,
        "id": 39
    },
    {
        "name": "重庆普惠豪生大酒店",
        "income": 22559.95,
        "laxin": 3026.23,
        "id": 40
    },
    {
        "name": "成都雅居乐豪生大酒店",
        "income": 37165.56,
        "laxin": 3350.49,
        "id": 46
    },
    {
        "name": "重庆秀山豪生大酒店",
        "income": 14304.18,
        "laxin": 1263.89,
        "id": 49
    },
    {
        "name": "重庆华宇温德姆至尊豪廷大酒店",
        "income": 44502.88,
        "laxin": 2017.94,
        "id": 54
    },
    {
        "name": "漳州明发温德姆至尊豪廷大酒店",
        "income": 31131.63,
        "laxin": 2009.67,
        "id": 57
    },
    {
        "name": "重庆锦怡豪生酒店",
        "income": 23424.84,
        "laxin": 1390.51,
        "id": 60
    },
    {
        "name": "丽江金林豪生大酒店",
        "income": 32268,
        "laxin": 1950,
        "id": 83
    },
    {
        "name": "重庆渝融豪生酒店",
        "income": 49090.72,
        "laxin": 2179.44,
        "id": 88
    },
    {
        "name": "厦门集美湖豪生大酒店",
        "income": 68937.66,
        "laxin": 4375.28,
        "id": 89
    },
    {
        "name": "资阳鼎晟泓府豪生大酒店",
        "income": 29971.03,
        "laxin": 3728.23,
        "id": 90
    },
    {
        "name": "厦门禹洲温德姆至尊豪廷大酒店",
        "income": 80762.47,
        "laxin": 3362.42,
        "id": 92
    },
    {
        "name": "成都宏鼎温德姆至尊豪廷大酒店",
        "income": 46261.54,
        "laxin": 3106.21,
        "id": 101
    },
    {
        "name": "昭通温德姆至尊豪廷大酒店",
        "income": 24655.18,
        "laxin": 1859.53,
        "id": 893
    },
    {
        "name": "昆明滇池豪生酒店",
        "income": 18505.28,
        "laxin": 1108.47,
        "id": 899
    },
    {
        "name": "丽江金林温德姆至尊豪廷度假酒店（全别墅型）",
        "income": 51949,
        "laxin": 1798,
        "id": 904
    },
    {
        "name": "梅州昌盛豪生大酒店",
        "income": 34164.08,
        "laxin": 2804.57,
        "id": 38
    },
    {
        "name": "郴州温德姆至尊豪廷大酒店",
        "income": 46038.16,
        "laxin": 3643.86,
        "id": 50
    },
    {
        "name": "邵阳湘林温德姆至尊豪廷大酒店",
        "income": 41711.4,
        "laxin": 3006.09,
        "id": 55
    },
    {
        "name": "文昌温德姆至尊豪廷大酒店",
        "income": 33116.6,
        "laxin": 1548.25,
        "id": 67
    },
    {
        "name": "抚州仙盖山温德姆至尊豪廷大酒店",
        "income": 11250,
        "laxin": 355.66,
        "id": 918
    }
]


// WEBPACK FOOTER //
// ./src/components/table/12/detaultData.js